export const baseSeller = "https://apicompanyfl2.comeia.org";
export const baseBuyer = "https://apifl2.comeia.org";
export const baseEngineer = "https://apiengineerfl2.comeia.org";
